import { useContext } from "react";
import { SecondLoaderContext } from "../contexts/SecondLoaderContext";

export function useSecondLoading() {
  const context = useContext(SecondLoaderContext);
  if (!context) {
    throw new Error("useLoading must be used within LoadingProvider.");
  }
  return context;
}
